import { Trans } from "@lingui/macro";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";

type NavigationBudgetProps = {
  mode: FormMode;
  onSelect: (() => void) | undefined;
};
export const NavigationBudget = observer(function NavigationBudget({
  mode,
  onSelect,
}: NavigationBudgetProps) {
  const { isDesktop } = useScreenType();
  const router = useRouter();

  const handleBudgetsClick = () => {
    router.push("/budgets/export");
    onSelect?.();
  };

  return (
    <AppSubNav>
      <NavBar.Item active={false} onClick={handleBudgetsClick}>
        <Trans>Budgets</Trans>
      </NavBar.Item>

      {isDesktop && <Icon name="chevron-right" />}

      <NavBar.Item active={false} isDisabled onClick={() => {}}>
        {mode === FormMode.EDIT && <Trans>Edit</Trans>}
        {mode === FormMode.CREATE && <Trans>Create</Trans>}
      </NavBar.Item>
    </AppSubNav>
  );
});
